/* Get TT document image from TamTamy */
export const getTamTamyImg = (url, size) => {
  const matches = /(.+)-\d+-\d+(\.\w+)?/.exec(url);
  if (matches?.length) {
    const [, baseUrl, extension = ""] = matches;
    if (baseUrl) {
      return `${baseUrl}-${size}-0${extension}`;
    }
    return;
  }
  return url;
};

/* Get TT document thumbnail image */
export const getImgThumb = (img) => getTamTamyImg(img.thumbUrl, 80);

export const getFilenameDetails = (filename) => {
  if (filename) {
    const pathlessFilename = filename?.slice(filename.lastIndexOf("/") + 1);
    if (
      pathlessFilename?.lastIndexOf(".") > 0 &&
      pathlessFilename.length - pathlessFilename?.lastIndexOf(".") <= 5
    ) {
      return {
        clearFilename: pathlessFilename.slice(0, pathlessFilename.lastIndexOf(".")),
        extension: pathlessFilename.slice(pathlessFilename.lastIndexOf(".") + 1),
        dotExtension: `.${pathlessFilename.slice(pathlessFilename.lastIndexOf(".") + 1)}`,
      };
    } else return { clearFilename: pathlessFilename, extension: null, dotExtension: null };
  } else return { clearFilename: null, extension: null, dotExtension: null };
};

export const getItemIcon = (filename) => {
  const ext = filename?.includes(".") ? filename.split(".").reverse()[0] : "";
  return (
    {
      doc: "file-word",
      docx: "file-word",
      xls: "file-excel",
      xlsx: "file-excel",
      ppt: "file-powerpoint",
      pptx: "file-powerpoint",
      pdf: "file-pdf",
      zip: "file-zip",
      png: "image",
      gif: "image",
      tiff: "image",
      jpg: "image",
      jpeg: "image",
      svg: "image",
    }[ext] || "file"
  );
};

export const getDocSizeString = (size) => {
  const sizeMB = Math.round((size / 1e6) * 100) / 100;
  if (sizeMB < 1) {
    const sizeKB = Math.round((size / 1000) * 100) / 100;
    return `${sizeKB}KB`;
  } else return `${sizeMB}MB`;
};

export const parseFile = (file, uploadInfo) => {
  return {
    ...file,
    type: ["IMAGE", "DOCUMENT"].includes(file.type)
      ? file.type
      : [
          "image/png",
          "image/gif",
          "image/apng",
          "image/avif",
          "image/jpeg",
          "image/webp",
          "image/bmp",
          "image/tiff",
        ].includes(file.type)
      ? "IMAGE"
      : "DOCUMENT",
    fileName: file.name,
    size: file.size,
    ...getFilenameDetails(file.name),
    ...uploadInfo,
  };
};

/* Document download url */
const getDocUrl = (doc, view) => {
  if (doc.type === "EXTERNAL_VIDEO") {
    return doc.videoUrl;
  }
  const url = `${window.location.origin}/bff/survey/documents/${doc.id}`;
  if (view) {
    return url.concat("/view");
  }
  return url;
};
/* Document download fucntion */
export const downloadDocument = async (doc, view = false) => {
  const docLink = document.createElement("a");
  if (!view) {
    docLink.download = doc.fileName;
  } else {
    docLink.target = "_blank";
  }
  const docUrl = getDocUrl(doc, view);
  console.log("Downloading", docUrl);
  docLink.href = docUrl;

  docLink.click();
  setTimeout(() => docLink.remove(), 500);
};
